import React, { forwardRef } from 'react';

import { noop } from 'ui-components/default-props/noop';

import style from '../../style.module.less';

export const ChallengeInput = forwardRef(
  /**
   * @param {object} props
   * @param {boolean} props.isDisabled
   * @param {React.MutableRefObject<HTMLInputElement>} [props.nextSiblingRef]
   * @param {React.MutableRefObject<HTMLInputElement>} [props.prevSiblingRef]
   * @param {(value: string) => void} props.setter
   * @param {string} props.value
   * @param {React.MutableRefObject} inputRef
   * @returns {JSX.Element}
   */
  ({ isDisabled, nextSiblingRef, prevSiblingRef, setter, value }, inputRef) => {
    /**
     * @param {React.KeyboardEvent} event
     */
    const onKeyDown = (event) => {
      const keyValue = event.key;

      try {
        const isBackspace = keyValue === 'Backspace';
        // backspace deletion
        if (isBackspace && value) {
          setter('');
        }
        // backspace navigation
        if (isBackspace && !value) {
          prevSiblingRef?.current?.focus();
        }

        // arrow navigation
        if (keyValue === 'ArrowLeft') {
          prevSiblingRef?.current?.focus();
        }
        if (keyValue === 'ArrowRight') {
          nextSiblingRef?.current?.focus();
        }

        // set value to mimic onChange handler
        const isNumber = !Number.isNaN(Number(keyValue));
        if (isNumber) {
          setter(keyValue);
          nextSiblingRef?.current?.focus();
        }
      } catch {
        // do nothing
      }
    };

    return (
      <input
        ref={inputRef}
        className={style['challenge-input']}
        disabled={isDisabled}
        maxLength={1}
        onChange={noop}
        onKeyDown={onKeyDown}
        pattern='[0-9]'
        value={value}
      />
    );
  },
);
